import * as React from 'react';
import {Link} from 'react-router-dom';

import {FlashBanner} from 'shells/flash-banner/flash-banner';

export function RegistrationCtaBanner() {
    return (
        <FlashBanner hasBorder={true} type='info'>
            <div>
                To access and customize your inbound SMS settings, please {/* @ts-expect-error */}
                <Link className='underline' to='/inbox/settings/sms'>
                    complete the registration process
                </Link>
                . This ensures all features are configured properly.
            </div>
        </FlashBanner>
    );
}
